import { AccessorsMutatorsDecorator, Model } from "../../helpers";
import { Property } from "./property.model";
import { FurnitureItem } from "./furniture-item.model";

/**
 * @class Asset
 * 
 */
export class Asset extends Model {

    setFurnitureItem(value) {

        if (!value) {

            return value;
        }

        return value instanceof FurnitureItem ? value : new FurnitureItem(value);
    }
}

AccessorsMutatorsDecorator('id', 'property', 'room_number', 'furniture_item', 'room_id', 'furniture_item_id', 'notes', 'property_id',
    'room_abbr', 'furniture_id', 'furniture_status', 'furniture_title', 'furniture_price', 'supplier_name', 'documents', 'updated_at', 'deleted_documents')(Asset);


// WEBPACK FOOTER //
// ./src/pms-api/models/asset.model.js